module.exports = __webpack_public_path__ + "202408221624/img/home_summer_3.155b6181.png";